export function maskCep(value: string): string {
  return value
    .replace(/\D/g, "")
    .slice(0, 8)
    .replace(/^(\d{5})(\d)/, "$1-$2");
}

export function maskCpf(value: string): string {
  return value
    .replace(/\D/g, "")
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function maskCnpj(value: string): string {
  return value
    .replace(/\D/g, "")
    .slice(0, 14)
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
}

export function maskDocumento(value: string, pessoaFisica: boolean): string {
  return pessoaFisica ? maskCpf(value) : maskCnpj(value);
}

export function maskTelefone(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 2) return digits.replace(/^(\d{0,2})/, "($1");
  if (digits.length <= 6) return digits.replace(/^(\d{2})(\d{0,4})/, "($1) $2");
  if (digits.length <= 10)
    return digits.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  return digits.replace(/^(\d{2})(\d{1})(\d{4})(\d{0,4})/, "($1) $2 $3-$4");
}

export function maskPlaca(value: string): string {
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .replace(/^([A-Z]{3})(\d{1,4})$/, "$1-$2");
}

export function maskDate(value: string): string {
  return value
    .replace(/\D/g, "")                 // somente números
    .slice(0, 8)                        // limita a 8 dígitos (ddMMyyyy)
    .replace(/^(\d{2})(\d)/, "$1/$2")   // dd/
    .replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3"); // dd/mm/
}
export const formatDateFromISO = (
  isoDate?: string | null
): string | null => {
  if (!isoDate) return null;

  const date = new Date(isoDate);

  if (isNaN(date.getTime())) return null;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // return `${day}/${month}/${year}`;
  return `${year}-${month}-${day}`;
};


export const formatDateFromISOTable = (
  isoDate?: string | null
): string | null => {
  if (!isoDate) return null;

  const date = new Date(isoDate);

  if (isNaN(date.getTime())) return null;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // return `${day}/${month}/${year}`;
  return `${day}-${month}-${year}`;
};


export function maskHour(value: string): string {
  return value
    .replace(/\D/g, "")           // somente números
    .slice(0, 4)                  // limita a HHmm
    .replace(/^(\d{2})(\d)/, "$1:$2");
};

export const formatHourFromISO = (
  isoDate?: string | null
): string | null => {
  if (!isoDate) return null;

  const date = new Date(isoDate);

  if (isNaN(date.getTime())) return null;

  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");

  return `${hour}:${minute}`;
};


export function maskCurrencyBRL(value: string): string {
  const onlyNumbers = value.replace(/\D/g, "");

  if (!onlyNumbers) return "";

  const number = Number(onlyNumbers) / 100;

  return number.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatCurrencyBRL(value?: number): string {
  if (value === null || value === undefined) return "";

  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function maskCurrencyAPIBRL(value: string): string {
  const onlyNumbers = value.replace(/\D/g, "");
  if (!onlyNumbers) return "";

  const number = Number(onlyNumbers);

  return number.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export const mergeDateAndHour = (
  date: string | null,
  hour: string | null
): string | null => {
  if (!date || !hour) return null;

  const [year, month, day] = date.split("-");
  return `${year}-${month}-${day}T${hour}:00`;
};


